export default function PHP_is_infinite() {
  return (
    <div>
      <h1>PHP_is_infinite</h1>
    </div>
  );
}
